import "./styles/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/holders/Header.js";
import Main from "./components/holders/Main.js";
import Footer from "./components/holders/Footer.js";
import { public_URL, resources_url } from "./components/utils/public_url.js";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theme_set: false,
      base_URL: public_URL,
      resources_URL: resources_url
    }
  }

  render() {
    
    return (
      <div className="App">
        <Header />
        <BrowserRouter>
          <Routes>
            <Route
              path='/'
              element={
                <Main
                  hostURL={this.state.base_URL}
                  resURL={this.state.resources_URL}
                />
              }
            >
            </Route>
          </Routes>
        </BrowserRouter>
        <Footer cr_year={new Date().getFullYear()-1} />
      </div>
    );
  }
}

export default App;